import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { TitleField } from "ui-components/Form";
import React, { useState } from "react";
import { FormTitle, Text, SelectField } from "ui-components/Form";
import { SwitchField } from "ui-components/Form";

const options = {
  movementType: ["FAST", "MEDIUM", "SLOW"],
  currencyCode: ["MYR", "SGD"],
  pickingRules: ["FIFO-OLN", "FIFO-MLN", "FEFO-EXPIRY", "FEFO-MLN", "LEFO-EXPIRY", "LEFO-MLN"],
};

function SKUInfo({ formRender, setValue, control, errors, mode = "ADD" }) {
  const [pickingRules, setPickingRules] = useState("");

  const onSelectChange = (name, option) => {
    setValue(name, option);
    setPickingRules(option);
    if (name === "pickingRules") {
      if (option === "FIFO-MLN") {
        setValue("mlnCtrl", true);
        setValue("expiryDateCtrl", false);
      } else if (option === "FEFO-EXPIRY" || option === "LEFO-EXPIRY") {
        setValue("expiryDateCtrl", true);
        setValue("mlnCtrl", false);
      } else if (option === "FEFO-MLN" || option === "LEFO-MLN") {
        setValue("mlnCtrl", true);
        setValue("expiryDateCtrl", true);
      } else {
        setValue("mlnCtrl", false);
        setValue("expiryDateCtrl", false);
      }
    }
  };

  const onSwitchChange = (checked) => {
    console.log("trigger onswitchevent");
    if (pickingRules !== "FEFO-EXPIRY") {
      // Prevent change if pickingRules is FEFO-EXPIRY
      setSwitchValue(checked);
      if (pickingRules === "FEFO-EXPIRY" && checked) {
        console.log("Switch toggled on for FEFO-EXPIRY");
      }
    }
  };

  const shouldDisableSwitch = (name) => {
    // if ((pickingRules === "FEFO-EXPIRY" || pickingRules === "LEFO-EXPIRY") && name === "expiryDateCtrl") {
    //   return true;
    // }
    // if ((pickingRules === "FIFO-MLN" || pickingRules === "FEFO-MLN" || pickingRules === "LEFO-MLN") && name === "mlnCtrl") {
    //   return true;
    // }
    if (
      (pickingRules === "FEFO-MLN" ||
        pickingRules === "LEFO-MLN" ||
        pickingRules === "FEFO-EXPIRY" ||
        pickingRules === "LEFO-EXPIRY" ||
        pickingRules === "FIFO-MLN" ||
        pickingRules === "FEFO-MLN" ||
        pickingRules === "LEFO-MLN") &&
      (name === "mlnCtrl" || name === "expiryDateCtrl")
    ) {
      return true;
    }
    return false;
    // if (name === "expiryDateCtrl" || name === "mlnCtrl") {
    //   return pickingRules === "FEFO-EXPIRY" || pickingRules === "LEFO-EXPIRY";
    // }
  };

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit SKU Information" : "SKU Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              if (property !== null) {
                const { disabled, editable, ...data } = property;
                const xs = 6 / 2;
                const fieldProps = {
                  ...data,
                  control,
                  errors,
                  ...(disabled && { disabled }),
                  ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
                };
                let renderField;
                switch (fieldProps.type) {
                  case "text":
                  case "number":
                    renderField = <Text field={fieldProps} />;
                    break;
                  case "select":
                    renderField = (
                      <SelectField
                        field={fieldProps}
                        options={options[data.name]}
                        onChange={(e, option) => {
                          onSelectChange(data.name, option);
                        }}
                      />
                    );
                    break;
                  case "switch":
                    renderField = <SwitchField field={fieldProps} />;
                    break;
                  case "title":
                    renderField = <TitleField label={data.label} />;
                    break;
                }

                return (
                  <Grid item xs={xs} key={index}>
                    {renderField}
                  </Grid>
                );
              } else return <Grid item xs={3} key={index}></Grid>;
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default SKUInfo;
